// TECH-3934 (D6): a score below its minimum-answered threshold is stored as an answer
// with the Formula.InsufficientData error and no value. These helpers recognise that
// error by its stable code (not its message) so displays and exports can show
// "Insufficient data" and carry the status `insufficient_data`.

import { ANSWER_STATUS__INSUFFICIENT_DATA } from '../models/Formula/types/minAnswered';

export { ANSWER_STATUS__INSUFFICIENT_DATA };

// review:manual: this English text reaches patient-facing views (QuestionFormula.formatAnswer, evaluateDynamicProperties). D6 chose the text but not its translation; localising it is left for a separate change.
export const INSUFFICIENT_DATA_TEXT = 'Insufficient data';

/**
 * @param {unknown} error
 * @returns {boolean}
 */
export const isInsufficientDataError = (error) =>
  !!error &&
  typeof error === 'object' &&
  /** @type {{ code?: unknown }} */ (error).code ===
    ANSWER_STATUS__INSUFFICIENT_DATA;

/**
 * @param {{ error?: unknown } | null | undefined} answer
 * @returns {string | null} `insufficient_data`, or null for any other answer
 */
export const getAnswerStatus = (answer) =>
  answer && isInsufficientDataError(answer.error)
    ? ANSWER_STATUS__INSUFFICIENT_DATA
    : null;
